export interface FormValidationParams {
    transactionType: string;
    propertyType: string;
    addressValid: boolean;
    hasBedroom: boolean;
    bedroomValid: boolean;
    hasEpc: boolean;
    epcValid: boolean;
    floorValid: boolean;
    hasNumberOfRooms: boolean;
    numberOfRoomsValid: boolean;
    isFloorRequired: boolean;
    getPrice: () => boolean;
}

export function isFormValid({
    transactionType,
    propertyType,
    addressValid,
    hasBedroom,
    bedroomValid,
    hasEpc,
    epcValid,
    hasNumberOfRooms,
    numberOfRoomsValid,
    floorValid,
    isFloorRequired,
    getPrice
}: FormValidationParams): boolean {
    return !!(
        transactionType &&
        propertyType &&
        addressValid &&
        (!hasBedroom || bedroomValid) &&
        (!hasEpc || epcValid) &&
        (!hasNumberOfRooms || numberOfRoomsValid) &&
        (!isFloorRequired || floorValid) &&
        getPrice()
    );
}
